module.exports = __webpack_public_path__ + "static/media/lamina12act2.c715c4fe.png";